import * as React from 'react';

export function useAsyncDebounce<F extends (...args: Parameters<F>) => void>(
  defaultFn: F,
  defaultWait = 300
): F {
  const timeoutRef = React.useRef<number | null>(null);

  const fnRef = React.useRef(defaultFn);

  React.useLayoutEffect(() => {
    fnRef.current = defaultFn;
  });

  const debouncedFn = React.useCallback(
    (...args: Parameters<F>): void => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      timeoutRef.current = window.setTimeout(() => {
        fnRef.current(...args);
        timeoutRef.current = null;
      }, defaultWait);
    },
    [defaultWait]
  );

  React.useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return debouncedFn as F;
}
